import { Column, Row } from 'app/design/primitives/box';
import { PlaceholderLine, PlaceholderMedia } from 'app/overrides/rn-placeholder';
import { createTheme as createDSTheme } from 'app/shopify';

const theme = createDSTheme();

export function MemberRowSkeleton() {
  return (
    <Row
      alignItems="center"
      gap="spacing.general.x4"
      paddingVertical="spacing.general.x5"
      style={{ borderTopWidth: 1, borderTopColor: theme.colors['border.secondary'] }}
    >
      <PlaceholderMedia style={{ width: 80, height: 80, borderRadius: 40 }} />
      <Column flex={1} gap="spacing.general.x2">
        <PlaceholderLine style={{ height: 14, width: '60%', borderRadius: theme.borderRadii['radius.lg'] }} />
        <PlaceholderLine style={{ height: 12, width: '40%', borderRadius: theme.borderRadii['radius.lg'] }} />
        <PlaceholderLine style={{ height: 12, width: '75%', borderRadius: theme.borderRadii['radius.lg'] }} />
      </Column>
    </Row>
  );
}
